import { render, staticRenderFns } from "./actualizacion-perfil.vue?vue&type=template&id=a35eac8a&"
import script from "./actualizacion-perfil.vue?vue&type=script&lang=ts&"
export * from "./actualizacion-perfil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports